function renderTextWithBreaks(s) {
  const str = String(s || "");
  const chunks = str.split("\n");
  return chunks.map((c, idx) => (
    <span key={idx}>
      {c}
      {idx < chunks.length - 1 ? <br /> : null}
    </span>
  ));
}

export default function RichText({ text, parts, className = "", onAction }) {
  if (Array.isArray(parts) && parts.length) {
    return (
      <span className={className}>
        {parts.map((p, i) => {
          const w = p?.w || "medium";

          if (w === "link") {
            return (
              <button
                key={i}
                type="button"
                className="tLinkInline"
                onClick={() => onAction?.(p.action)}
                title={p.t}
              >
                {renderTextWithBreaks(p.t)}
              </button>
            );
          }

          return (
            <span key={i} className={w === "bold" ? "tBold" : "tMedium"}>
              {renderTextWithBreaks(p?.t)}
            </span>
          );
        })}
      </span>
    );
  }

  return <span className={className}>{renderTextWithBreaks(text)}</span>;
}